/**
 * @module Task
 * Container Component Task List
 */
import React, {useState, useEffect} from 'react';
import classNames from 'classnames';
import {SVGICONS} from '@ey/icons';
import {useSelector, useDispatch} from 'react-redux';
import Utility from '../../../util/utilityfunctions';
import {clearErrors} from '../../../actions/erroractions';
import {labels, currentResource} from '../../../util/utils';
import {getErrorsForSummary} from './Helper';
import StyledErrorSummary from './StyledErrorSummary';

export default function ErrorSummary(props) {
	const {isRbac, error, errorMessage, level} = useSelector((store) => getErrorsForSummary(store, props));
	const actionDispatcher = useDispatch();
	const [opened, setOpened] = useState(false),
		[message, setMessage] = useState(errorMessage);

	const hideError = () => {
		setOpened(!opened);

		actionDispatcher(clearErrors()).then(() => {
			setOpened(false);
		});
	};

	useEffect(() => {
		if (isRbac) {
			let m;
			if (error.length > 0) {
				let errorCode = 0;
				if (error[0].indexOf(' - ') > 0) {
					errorCode = error[0].substr(0, error[0].indexOf(' -'));
				} else {
					errorCode = JSON.parse(JSON.stringify(error[0]));
				}
				m = '<strong>' + errorCode + ': ' + '</strong>' + currentResource.RbacErrors[errorCode];
			} else {
				m = '<strong>' + error.ErrorCode + ': ' + '</strong>' + currentResource.RbacErrors[error.ErrorCode];
			}
			setMessage(m);
		} else {
			let m = Utility.getErrorMessageFromResponse(errorMessage);
			if (m === 'Network Error') {
				m = labels.networkErrorMessage;
			}
			setMessage(m);
		}
	}, [isRbac, error, errorMessage]);

	const iconClassName = classNames({['error-icon']: level === 'error', ['success-icon']: level === 'success'});

	return (
		<>
			{message ? (
				<StyledErrorSummary className={`${'errorMessageWrapper'} ${opened ? 'hide-error-summary' : ' '}`}>
					<span className={iconClassName} />
					<span className="error-message">{Utility.createRichTextElement(message)}</span>
					<SVGICONS
						styleName="medium pull-right close-icon"
						hoverText={labels.closeLabel}
						name="close-outline"
						onIconClick={hideError}
					/>
				</StyledErrorSummary>
			) : null}
		</>
	);
}
